<template>
  <div>
    <vxe-grid
      class="pdCostsOrder-table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.pdcostsOrderStatus === 'R' || row.pdcostsOrderStatus === 'D'
              ? 'danger'
              : row.pdcostsOrderStatus === 'S'
              ? 'warning'
              : row.pdcostsOrderStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_pdcostsOrderStatus }}
        </el-tag>
      </template>
      <template v-slot:difference="{ row }">
        <span
          v-if="row.difference != undefined"
          :class="
            row.difference == 0
              ? ''
              : row.difference < 0
              ? 'label-red'
              : 'label-green'
          "
        >
          {{ `${row.difference > 0 ? '+' : ''}${format(row.difference)}` }}
        </span>
        <span v-if="row.difference != undefined">
          {{ row.v_currencyUnit }}
        </span>
      </template>
      <template v-slot:differenceRate="{ row }">
        <span
          v-if="row.differenceRate != undefined"
          :class="
            row.differenceRate == 0
              ? ''
              : row.differenceRate < 0
              ? 'label-red'
              : 'label-green'
          "
        >
          {{ `${row.differenceRate > 0 ? '+' : ''}${row.differenceRate}%` }}
        </span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'detail',
                  params: { pdCostsOrderCode: row.pdCostsOrderCode },
                  query: { orderNo: row.orderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="
              allow('M') &&
                (row.pdcostsOrderStatus === 'N' ||
                  row.pdcostsOrderStatus === 'R')
            "
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'edit',
                  params: { pdCostsOrderCode: row.pdCostsOrderCode },
                  query: { orderNo: row.orderNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="
              allow('D') &&
                (row.pdcostsOrderStatus === 'N' ||
                  row.pdcostsOrderStatus === 'R')
            "
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_submit_review') || '提交审核'"
            placement="top"
            v-if="
              allow('S') &&
                (row.pdcostsOrderStatus === 'N' ||
                  row.pdcostsOrderStatus === 'R')
            "
          >
            <i class="el-icon-s-check tool-btn" @click="submit(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_audit') || '审核'"
            placement="top"
            v-if="allow('T') && row.pdcostsOrderStatus === 'S'"
          >
            <i
              class="el-icon-check tool-btn"
              @click="
                $emit('openEditPage', {
                  pageType: 'audit',
                  params: { pdCostsOrderCode: row.pdCostsOrderCode },
                  query: { orderNo: row.orderNo },
                })
              "
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
  methods: {
    del({ pdCostsOrderCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .pdCostsOrderDelApi({ pdCostsOrderCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
          return
        }
        this.$message({
          message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
          type: 'success',
          showClose: true,
        })
        this.$emit('reload')
      })
    },
    submit({ pdCostsOrderCode }) {
      this.$confirm(
        this.$l('INDEX.tips_question_submitAudit') || '是否提交审核？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        this.loadingOpen()
        const res = await this.$api
          .pdCostsOrderSubmitApi({ pdCostsOrderCode })
          .catch(() => null)
        this.loadingClose()
        if (!res) return
        const { status } = res
        if (status !== 200) {
          this.$message.error(
            this.$l('INDEX.tips_submission_failed') || '提交失败！'
          )
          return
        }
        this.$message({
          showClose: true,
          message: this.$l('INDEX.tips_Submitted_successfully') || '提交成功！',
          type: 'success',
        })
        this.$emit('reload')
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.pdCostsOrder-table {
  .label-red {
    color: red !important;
  }
  .label-green {
    color: green !important;
  }
}
</style>
